import React, { useEffect, useState } from "react";

import { subscribeMatchMedia } from "../methods/browser";

interface customQueryProps {
    queryType: "max-width" | "min-width" | "max-height" | "min-height";
    sizePx: string;
    initialState?: boolean;
}

interface defaultQueryProps {
    queryType: "mobile" | "medium-screen" | "desktop";
    initialState?: boolean;
}

type Props = customQueryProps | defaultQueryProps;

const useMediaQuery = ({
    queryType,
    initialState = false,
    ...props
}: Props) => {
    const { sizePx } = props as customQueryProps;

    let query: string = "";

    switch (queryType) {
        case "max-width":
            query = `(max-width: ${sizePx}px)`;
            break;
        case "min-width":
            query = `(min-width: ${sizePx}px)`;
            break;
        case "max-height":
            query = `(max-height: ${sizePx}px)`;
            break;
        case "min-height":
            query = `(min-height: ${sizePx}px)`;
            break;
        case "mobile":
            query = `(max-width: 576px)`;
            break;
        case "medium-screen":
            query = `(max-width: 991px)`;
            break;
        case "desktop":
            query = `(min-width: 992px)`;
            break;

        default:
            break;
    }

    // Keep SSR and first client render aligned — read viewport only after mount.
    const [matches, setMatches] = useState(initialState);

    useEffect(() => {
        if (!query || typeof window === "undefined") {
            return;
        }

        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);

        setMatches(media.matches);

        return subscribeMatchMedia(media, listener);
    }, [query]);

    return matches;
};

export default useMediaQuery;
